import React, {
    useMemo, useState,
} from 'react'
import PropTypes from 'prop-types'
import AttachmentContext from './AttachmentContext'

const propTypes = { children: PropTypes.element.isRequired }

const AttachmentContextProvider = ({ children }) => {
    const [
        attachments,
        setAttachments,
    ] = useState(
        { attachments: [] },
    )

    const value = useMemo(() => {
        return {
            attachments,
            saveAttachments: setAttachments,
        }
    }, [attachments])

    return (
        <AttachmentContext.Provider
            value={value}
        >
            {children}
        </AttachmentContext.Provider>
    )
}

AttachmentContextProvider.propTypes = propTypes

export default AttachmentContextProvider
